import {
    InvestmentDataColumnConfiguration,
    ViewColumnType,
} from '@wdx/shared/swagger-gen';

export const STANDING_ORDER_DEFAULT_PRIMARY_COLUMNS: InvestmentDataColumnConfiguration[] =
    [
        {
            name: 'PORTFOLIO_STANDING_ORDERS_PAY_TO',
            path: 'to',
            fieldType: ViewColumnType.Text,
        },
        {
            name: 'PORTFOLIO_STANDING_ORDERS_FREQUENCY',
            path: 'frequencyText',
            fieldType: ViewColumnType.Text,
        },

        {
            name: 'PORTFOLIO_STANDING_ORDERS_AMOUNT',
            path: 'amountCurrency',
            fieldType: ViewColumnType.Currency,
        },
    ];

export const STANDING_ORDER_DETAIL_DEFAULT_FIELDS: InvestmentDataColumnConfiguration[] =
    [
        {
            path: 'startDate',
            name: 'PORTFOLIO_STANDING_ORDERS_START',
            fieldType: ViewColumnType.Date,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
        {
            path: 'endDate',
            name: 'PORTFOLIO_STANDING_ORDERS_END',
            fieldType: ViewColumnType.Date,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
        {
            path: 'standingOrderId',
            name: 'PORTFOLIO_STANDING_ORDERS_ID',
            fieldType: ViewColumnType.Text,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
        {
            path: 'accountId',
            name: 'PORTFOLIO_STANDING_ORDERS_ACCOUNT_ID',
            fieldType: ViewColumnType.Text,
            sectionCode: null,
            isCopyable: false,
            isSortable: false,
            isSearchable: false,
        },
    ];
